import { render } from "./SelectRadioWithImage.vue?vue&type=template&id=108fbae8&lang=true"
import script from "./SelectRadioWithImage.vue?vue&type=script&lang=js"
export * from "./SelectRadioWithImage.vue?vue&type=script&lang=js"
script.render = render

export default script